module.exports = __webpack_public_path__ + "img/app6.ea2486e5.jpg";